const VERSION = '2.2.0';
export function getVersionString() {
    return VERSION;
}